import React from 'react';
import { TextButton } from '../../../design-system';
import { CTAsWrapper, GroupOfCTAs, ShowResultsCTA, ResetFilters } from './CtaGroup.style';

interface CtaGroupProps {
  onReset: () => void;
  totalCount: number;
  closeFilter: () => void;
}

const CtaGroup: React.FC<CtaGroupProps> = ({ onReset, totalCount, closeFilter }) => {
  const isAlpha = !process.env.IS_LEGACY;
  const isZeroResults = totalCount === 0;

  const resetAllFilters = () => {
    onReset();
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
  };

  return (
    <CTAsWrapper data-testid="filters-main-ctas-wrapper">
      <GroupOfCTAs>
        {isAlpha ? (
          <>
            <TextButton
              variant="primary"
              isFullWidth
              disabled={isZeroResults}
              onClick={closeFilter}
              data-testid="apply-filters-cta"
            >
              Finish and close
            </TextButton>
            <TextButton
              variant="secondary"
              isFullWidth
              onClick={resetAllFilters}
              data-testid="reset-filters-cta"
            >
              Reset Filters
            </TextButton>
          </>
        ) : (
          <>
            <ShowResultsCTA
              data-testid="apply-filters-cta"
              isZeroResults={isZeroResults}
              onClick={closeFilter}
            >
              Finish and close
            </ShowResultsCTA>
            <ResetFilters data-testid="reset-filters-cta" onClick={resetAllFilters}>
              Reset Filters
            </ResetFilters>
          </>
        )}
      </GroupOfCTAs>
    </CTAsWrapper>
  );
};

export default CtaGroup;
